<div [ngSwitch]="action().type">
  <button
    *ngSwitchCase="ActionButtonEnum.BUTTON"
    class="border-0 bg-transparent s-p-0"
    [ngClass]="{ 'd-none': action().hidded ? action().hidded(row()) : false }"
    [style.color]="action().color"
    [matTooltip]="action().name"
    [disabled]="
      action().disabled
        ? action().disabled(row())
        : action()[row().idArquivo + DISABLED_SUFFIX] || false
    "
    (click)="emitAction()"
  >
    <mat-icon>
      {{ action().icon }}
    </mat-icon>
  </button>

  <a
    *ngSwitchCase="ActionButtonEnum.LINK"
    [routerLink]="action().path(row())"
    class="border-0 bg-transparent"
    [style.color]="action().color"
    [matTooltip]="action().name"
  >
    <mat-icon>
      {{ action().icon }}
    </mat-icon>
  </a>
</div>
